/**
 * @module features/Bookmarks/ui
 */
export { default as BookmarkButton } from './components/BookmarkButton.jsx';
